import { DownloadError, DownloadResponse } from '../types/downloads';
import { api } from '../services/index';
import { AxiosResponse } from 'axios';

export class FileService {
  async downloadFile(endpoint: string): Promise<DownloadResponse> {
    try {
      const response = await api.post(endpoint, { responseType: 'blob' });

      const blob = await response.data;
      const filename = this.getFilenameFromResponse(response);

      return { blob, filename };
    } catch (error) {
      throw this.handleError(error);
    }
  }

  private getFilenameFromResponse(response: AxiosResponse): string {
    const contentDisposition = response.headers['content-disposition'];
    if (!contentDisposition) return 'downloaded-file';

    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    return filenameMatch ? filenameMatch[1].replace(/['"]/g, '') : 'survey';
  }

  private handleError(error: unknown): DownloadError {
    if (error instanceof Error) {
      return { message: error.message };
    }
    return { message: 'Unknown error occurred' };
  }
}
